<template>
  <section id="benefits" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-card style="width: 100%">
            <!-- Encabezado atractivo -->
            <h1
              class="text-h4 text-center font-weight-bold text-uppercase mt-6"
              style="color: #a2c334"
            >
              ¡Transforma tu taller mecánico en minutos!
            </h1>
            <v-divider class="my-6"></v-divider>
            <v-row class="text-center">
              <v-col>
                <v-card>
                  <!-- Imagen de oferta destacada -->
                  <v-img
                    src="~@/assets/img/oferta.png"
                    max-width="220"
                    class="position-absolute oferta-img"
                  ></v-img>

                  <v-card-text class="text-center">
                    <!-- Título del producto -->
                    <div
                      class="text-h4 font-weight-bold text-uppercase mt-6"
                      style="color: #a2c334"
                    >
                      OSD para Talleres Mecánicos
                    </div>
                    <v-divider class="my-4" />

                    <!-- Lista de beneficios -->
                    <div
                      class="text-subtitle-1 text-uppercase"
                      style="color: #a2c334"
                    >
                      <v-icon left>mdi-check</v-icon> Gestión eficiente de
                      órdenes y notas de venta
                    </div>
                    <v-divider class="my-2" />
                    <div
                      class="text-subtitle-1 text-uppercase"
                      style="color: #a2c334"
                    >
                      <v-icon left>mdi-check</v-icon> Cotizaciones precisas y
                      control total de servicios
                    </div>
                    <v-divider class="my-2" />
                    <div
                      class="text-subtitle-1 text-uppercase"
                      style="color: #a2c334"
                    >
                      <v-icon>mdi-check</v-icon> Registro detallado de clientes
                      y vehículos
                    </div>
                    <v-divider class="my-2" />
                    <div
                      class="text-subtitle-1 text-uppercase"
                      style="color: #a2c334"
                    >
                      <v-icon left>mdi-check</v-icon> Firma digital integrada y
                      galería de fotos
                    </div>

                    <v-divider class="my-4" />

                    <!-- Llamado a la acción -->
                    <v-btn
                      rounded
                      style="background-color: #a2c334"
                      class="mt-6 white--text"
                      large
                      :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20optimizar%20mi%20taller%20con%20OSD.'"
                      target="_blank"
                    >
                      ¡Descubre cómo mejorar tu taller hoy!
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
$main_color: #283e79;

.oferta-img {
  top: -30px;
  left: 100%;
  transform: translateX(-50%);
  position: absolute;
}
</style>
